import { Dropdown, DropdownItem } from '@/components/common/dropdown';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { CommonConfigContext } from '@/contexts/ConfigContext';
import { VoiceCode, Voice as VoiceEnum } from '@/models/Voice';
import { getMainUserState } from '@/modules/main/selector';
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

type VoiceSelectorProps = {
    voiceSound: VoiceEnum;
    setVoiceSound: Dispatch<SetStateAction<VoiceEnum>>;
};

const voiceOrder: Array<number> = [
    VoiceEnum.English1,
    VoiceEnum.Thai1,
    VoiceEnum.Korean1,
    VoiceEnum.Vietnamese,
    VoiceEnum.Mandarin1,
    //VoiceEnum.Mandarin2,
    VoiceEnum.Cantonese1,
    //VoiceEnum.Cantonese2,
    VoiceEnum.Indonesian1,
    VoiceEnum.Japanese,
    VoiceEnum.BrazilianPortuguese,
    VoiceEnum.Russian,
    VoiceEnum.Arabic,
    VoiceEnum.Hindi,
];
export const VoiceSelector = (props: VoiceSelectorProps) => {
    const { voiceSound, setVoiceSound } = props;
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { langOnly, langExclude } = useContext(CommonConfigContext);
    const { LobbyCode: serLobbyCode } = useSelector(getMainUserState);
    const [voices, setVoices] = useState<Array<number>>([]);
    const { t } = useTranslation();
    const handleChangeVoice = (voice: VoiceEnum) => {
        setVoiceSound(voice);
        playButtonAudio();
    };
    useEffect(() => {
        const v = Object.values(voiceOrder)
            .filter(value => typeof value === 'number')
            .filter(l => {
                const voice = l as VoiceEnum;
                const shortLang = VoiceCode[voice];
                if (
                    langExclude[shortLang]?.lobby?.includes(serLobbyCode) ||
                    langExclude[shortLang]?.lobby?.includes('all')
                )
                    return false;
                if (langOnly[shortLang]) {
                    if (langOnly[shortLang]?.includes(serLobbyCode)) {
                        return true;
                    }
                    return false;
                }
                return true;
            })
            .map(v => Number(v));
        setVoices(v);
    }, []);

    return (
        <Dropdown
            className="voice-selector"
            placeholder={`setting.sound_list.${voiceSound}`}
        >
            {voices.map((v, i) => {
                const isChecked = voiceSound === v;
                return (
                    <DropdownItem
                        onClick={() => handleChangeVoice(v)}
                        key={`voice-selector-${i}`}
                        text={<>{t(`setting.sound_list.${v}`)}</>}
                        isChecked={isChecked}
                    />
                );
            })}
        </Dropdown>
    );
};
